import React from "react";

export default function Modal({
  isOpen,
  onClose,
  onConfirm,
  title,
  confirmText = "Confirmar",
  cancelText = "Voltar",
  children,
}) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50"
      onClick={onClose}
      style={{
        backgroundColor: "white",
        borderRadius: "1rem",
        padding: "1rem",
        overflowY: "auto",
      }}
    >
      <div
        className="bg-white rounded-xl shadow-xl max-w-lg w-full p-6 flex flex-col justify-center"
        onClick={(e) => e.stopPropagation()}
        style={{
          minWidth: 320,
          maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        {title && (
          <h2 className="text-2xl font-semibold mb-6 text-center">{title}</h2>
        )}

        <div className="mb-6 flex-grow flex items-center justify-center">
          {children}
        </div>

        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className="button button-azul"
            style={{
              minWidth: 120,
              padding: "0.6rem 1.2rem",
              marginTop: "1rem",
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className="button button-vermelho"
            style={{ minWidth: 120, padding: "0.6rem 1.2rem" }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
